import { type ReactNode } from 'react';

import { FormattedMessage, FormattedNumber } from 'dibs-react-intl';
import PersonSearch from 'dibs-icons/exports/PersonSearch.ts';
import SupportAgent from 'dibs-icons/exports/SupportAgent.ts';
import MoneyBackGuarantee from 'dibs-icons/exports/MoneyBackGuarantee.ts';
import Highlights from 'dibs-icons/exports/Highlights.ts';
import Money from 'dibs-icons/exports/Money.ts';

import { TRADE_STATUS } from '../../tradeBenefitsConstants.ts';

type NextStatusBenefit = {
    title: ReactNode;
    icon: ReactNode;
};

export const NEXT_STATUS_BENEFITS: Record<
    typeof TRADE_STATUS.SILVER | typeof TRADE_STATUS.GOLD | typeof TRADE_STATUS.PLATINUM,
    NextStatusBenefit[]
> = {
    [TRADE_STATUS.SILVER]: [
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.silver.sourcingSupport"
                    defaultMessage="Specialized Sourcing Support"
                />
            ),
            icon: <PersonSearch variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.silver.accountRep"
                    defaultMessage="Dedicated Account Representative"
                />
            ),
            icon: <SupportAgent variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.silver.moneyBackGuarantee"
                    defaultMessage="60-Day Money-Back Guarantee"
                />
            ),
            icon: <MoneyBackGuarantee variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.silver.publicity"
                    defaultMessage="Consideration for 1stDibs Publicity Opportunities"
                />
            ),
            icon: <Highlights variation="40" />,
        },
    ],
    [TRADE_STATUS.GOLD]: [
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.gold.tradeSupport"
                    defaultMessage="Dedicated Trade Support Specialist"
                />
            ),
            icon: <SupportAgent variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.gold.cashBack"
                    defaultMessage="{amount} Cash Back for Every {points} Points Earned"
                    values={{
                        amount: (
                            <FormattedNumber
                                value={25}
                                style="currency"
                                currency="USD"
                                maximumFractionDigits={0}
                            />
                        ),
                        points: <FormattedNumber value={5000} />,
                    }}
                />
            ),
            icon: <Money variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.gold.moneyBackGuarantee"
                    defaultMessage="90-Day Money-Back Guarantee"
                />
            ),
            icon: <MoneyBackGuarantee variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.gold.editorial"
                    defaultMessage="Consideration for 1stDibs Editorial Opportunities"
                />
            ),
            icon: <Highlights variation="40" />,
        },
    ],
    [TRADE_STATUS.PLATINUM]: [
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.platinum.cashBack"
                    defaultMessage="{amount} Cash Back for Every {points} Points Earned"
                    values={{
                        amount: (
                            <FormattedNumber
                                value={50}
                                style="currency"
                                currency="USD"
                                maximumFractionDigits={0}
                            />
                        ),
                        points: <FormattedNumber value={5000} />,
                    }}
                />
            ),
            icon: <Money variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.platinum.moneyBackGuarantee"
                    defaultMessage="120-Day Money-Back Guarantee"
                />
            ),
            icon: <MoneyBackGuarantee variation="40" />,
        },
        {
            title: (
                <FormattedMessage
                    id="abt.TradeBenefitsNextStatus.platinum.dibs50"
                    defaultMessage="Preferential Consideration for Inclusion in the 1stDibs50"
                />
            ),
            icon: <Highlights variation="40" />,
        },
    ],
};
